import {
    GET_CHART_COUNT,
    GET_CHART_POST,
    GET_CHART_POINT,
    GET_CHART_VIEW,
    GET_MYPOST_LIST,
    DELETE_MYPOST_LIST,
    POST_ARTICLE,
    POST_ATTACHMENT,
    DELETE_ATTACHMENT,
    DELETE_ALL_ATTACHMENT,
    UPDATE_ARTICLE,
    GET_CHART_LIKE
  } from 'shared/constants/ActionTypes';
  
  const initialState = {
    cCount: null,
    cPost: null,
    cPoint: null,
    cView: null,
    cLike: null,
    cMyPostList: null,
    cDeleteMyPost: null,
    cDocAttachment: []
  };
  
  const getChartMyPostReducer = (state=initialState,action) => {
    switch (action.type) {
        case GET_CHART_COUNT:
            return {
                ...state,
                cCount:action.payload
            }
        case GET_CHART_POINT:
            return {
                ...state,
                cPoint:action.payload
            }
        case GET_CHART_VIEW:
            return {
                ...state,
                cView:action.payload
            }
        case GET_CHART_POST:
            return {
                ...state,
                cPost:action.payload
            }
        case GET_CHART_LIKE:
            return {
                ...state,
                cLike:action.payload
            }
        case GET_MYPOST_LIST:
            return {
                ...state,
                cMyPostList:action.payload
            }
        case DELETE_MYPOST_LIST:
            return {
                ...state,
                cDeleteMyPost:action.payload
            }
        case POST_ARTICLE:
            return {
                ...state
            }
        case POST_ATTACHMENT:
            return {
                ...state,
                cDocAttachment: [...state.cDocAttachment, action.payload]
            }
        case UPDATE_ARTICLE:
            return {
                ...state
            }
        case DELETE_ATTACHMENT:
            return {
                ...state,
                cDocAttachment: action.payload.length === 0 ? [] : action.payload
            }
        case DELETE_ALL_ATTACHMENT:
            return {
                ...state,
                cDocAttachment: []
            }
        default:
            return {
                ...state
            }
    }
};

export default getChartMyPostReducer;